var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5236 21.2252C23.2703 21.2252 23.0169 21.1319 22.8169 20.9319C22.4302 20.5452 22.4302 19.9052 22.8169 19.5185L25.5236 16.8119L22.8169 14.1052C22.4302 13.7185 22.4302 13.0785 22.8169 12.6919C23.2036 12.3052 23.8436 12.3052 24.2302 12.6919L27.6436 16.1052C28.0303 16.4919 28.0303 17.1319 27.6436 17.5185L24.2302 20.9319C24.0302 21.1319 23.7769 21.2252 23.5236 21.2252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8436 17.8118H13.2836C12.7369 17.8118 12.2836 17.3584 12.2836 16.8118C12.2836 16.2651 12.7369 15.8118 13.2836 15.8118H26.8436C27.3902 15.8118 27.8436 16.2651 27.8436 16.8118C27.8436 17.3584 27.3902 17.8118 26.8436 17.8118Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9502 28.3985C9.08357 28.3985 4.28357 23.5985 4.28357 16.7319C4.28357 9.86519 9.08357 5.06519 15.9502 5.06519C16.4969 5.06519 16.9502 5.51852 16.9502 6.06519C16.9502 6.61185 16.4969 7.06519 15.9502 7.06519C10.2569 7.06519 6.28357 11.0385 6.28357 16.7319C6.28357 22.4252 10.2569 26.3985 15.9502 26.3985C16.4969 26.3985 16.9502 26.8519 16.9502 27.3985C16.9502 27.9452 16.4969 28.3985 15.9502 28.3985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.84ff187983f4868b7eb3c10f79de40d8.svg";
export { ForwardRef as ReactComponent };